import { Http } from "@/plugins/http";

export class IclService {
  /**
   * Возвращает список ресурсов
   * @return Promise<any>
   */
  static getUnits() {
    return Http.get(`hc/units`, { params: { lang: "ru" } }).then(response => response.data.data);
  }

  /**
   * Возвращает детальную информацию
   * @property {number} unitId
   * @return Promise<any>
   */
  static getUnit(unitId) {
    return Http.get(`hc/units/${unitId}`, { params: { lang: "ru" } }).then(response => response.data.data);
  }

  static getPatients(search) {
    return Http.get(`hc/patients`, { params: { lang: "ru", full_name: search } }).then(response => response.data.data);
  }

  /**
   * Возвращает расписание за указанный день
   * @property {string} date
   * @return Promise<any>
   */
  static getTimetableByDate(date) {
    return Http.get(`hc/timetable/${date}`, { params: { lang: "ru" } }).then(response => response.data.data);
  }

  /**
   * Возвращает детальную информацию о записи
   * @property {number} id
   * @return Promise<any>
   */
  static getTimetableRecord(id) {
    return Http.get(`hc/timetable/entry/${id}`, { params: { lang: "ru" } }).then(response => response.data.data);
  }

  /**
   * Возвращает детальную информацию
   * @property {IclTimeTask} form
   * @return Promise<any>
   */
  static createTimeTask(form) {
    return Http.post(`hc/timetable`, {
      unit_id: form.unit.id,
      start_at: `${form.date} ${form.time}`,
      patient_id: form.patient.id,
      duration: form.duration,
      description: form.description,
      services: form.services.filter(item => item.selected),
    })
      .then(response => response.data.data)
      .catch(error => {
        console.log("IclService.createTimeTask", error.response);
        return null;
      });
  }
}
